import React from 'react'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { CompanyConsumer } from '../../../../CompanyContext'
import CompanyContentWrapper from '../CompanyContentWrapper'
import CompanyDownPayment from './CompanyDownPayment'
import { SEO } from '../../../Seo/seo'
import { payments } from '../../../../utils/pages-meta'
import { useIntl } from 'react-intl'
import InActiveCompanyContent from '../../../InActiveCompanyContent'
import { CompanyDownPaymentProvider, CompanyDownPaymentConsumer } from '../../../../CompanyDownPaymentContext'

const CompanyDownPaymentContent = ({ checkCompanyData, cid }) => {
  const intl = useIntl()
  return (
    <CompanyContentWrapper checkCompanyData={checkCompanyData} cid={cid}>
      <AuthenticatedUserConsumer>
        {({ selectedCompany }) => (
          <>
            {!!selectedCompany && !!Object.keys(selectedCompany).length &&
            <>
              <SEO title={intl.formatMessage({ id: 'PageTitle.DownPayment' }) + ' - ' + selectedCompany.taxpayer_name}
                   pathname={window.location.origin}
                   titleTemplate={intl.formatMessage({ id: 'E-Tax-Workspace' })}
                   image={payments.image}
                   description={intl.formatMessage({ id: 'PageTitle.DownPayment' }) + ' - ' + selectedCompany.taxpayer_name}
              />
              {!!selectedCompany.active && !!selectedCompany.company_user_active ?
                <CompanyConsumer>
                  {({ setBreadCrumbLinks, setBreadCrumbCurrent }) => (
                    <CompanyDownPaymentProvider cid={cid}>
                      <CompanyDownPaymentConsumer>
                        {({ getDownPaymentRequests }) => (
                          <CompanyDownPayment selectedCompany={selectedCompany}
                                              getDownPaymentRequests={getDownPaymentRequests}
                                              setBreadCrumbLinks={setBreadCrumbLinks}
                                              setBreadCrumbCurrent={setBreadCrumbCurrent}/>
                        )}
                      </CompanyDownPaymentConsumer>
                    </CompanyDownPaymentProvider>
                  )}
                </CompanyConsumer>
                : <InActiveCompanyContent/>
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </CompanyContentWrapper>
  )
}

export default CompanyDownPaymentContent
